import { ImageLoadingState, Svg } from "@/types";
import { Box, CSSObject } from "@mui/system";
import * as React from "react";
import DummyIcon from "../Icon/Dummy";
import ImagePlaceHolder from "../Placeholder/ImagePlaceHolder";

export default function Image({
  img,
  alt,
  maxWidth = "100%",
  maxHeight = "inherit",
  objectFit = "contain",
  containerWidth = "100%",
  containerHeight = "100%",
  imageWidth = "100%",
  imageHeight = "100%",
  borderRadius = 0,
  containerStyles = {},
  errorIcon,
}: ImageProps): ReturnType<React.FC> {
  const [loadedState, setLoadedState] = React.useState(
    !img ? "error" : "loading"
  );
  const ErrorIcon = errorIcon ?? DummyIcon;
  return (
    <Box
      sx={{
        width: containerWidth,
        height: containerHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        borderRadius,
        overflow: "hidden",
        ...containerStyles,
      }}
    >
      {loadedState === "error" ? (
        <ErrorIcon sx={{ width: "inherit", height: "inherit" }} />
      ) : loadedState === "loading" ? (
        <ImagePlaceHolder width={maxWidth} height={maxHeight} />
      ) : null}
      {img && (
        <img
          src={img}
          alt={alt ?? "img"}
          style={{
            width: imageWidth,
            height: imageHeight,
            objectFit: objectFit,
            maxWidth,
            maxHeight,
            opacity: loadedState !== "loaded" ? 0 : 1,
          }}
          onLoad={() => setLoadedState("loaded")}
          onError={() => setLoadedState("error")}
        />
      )}
    </Box>
  );
}

interface ImageProps {
  img: string;
  alt: string;
  maxWidth?: string;
  maxHeight?: string;
  containerWidth?: string;
  containerHeight?: string;
  imageWidth?: string;
  imageHeight?: string;
  loadedStatus?: ImageLoadingState;
  objectFit?:
    | "cover"
    | "fill"
    | "none"
    | "contain"
    | "scale-down"
    | "inherit"
    | "initial";
  borderRadius?: string | 0;
  errorIcon?: Svg;
  containerStyles?: CSSObject;
}
